import {
    Box,
    SxProps,
    Theme,
    useMediaQuery
} from "@mui/material";
import {
    MeetingStatus,
    useMeetingStatus
} from "amazon-chime-sdk-component-library-react";

import { APPBAR_ID } from "../../sidebar/Sidebar";
import AttachmentsUploadStatusDrawer from "../../attachment/AttachmentsUploadStatusDrawer";
import { QuickAccessKeys } from "../../quickAccess/QuickAccessKeys";
import { showQuickAccessKeysSelector } from "../../../lib/sidebar/SidebarRecoilStates";
import { useRecoilValue } from "recoil";

export const FABManager = () => {
    const meetingStatus = useMeetingStatus();
    const isMeetingActive = meetingStatus === MeetingStatus.Succeeded || meetingStatus === MeetingStatus.Reconnecting;
    const showQuickAccessKeys = useRecoilValue<boolean>(showQuickAccessKeysSelector);
    const isLandscape = useMediaQuery("(orientation: landscape)");
    const appBarHeight = document.getElementById(APPBAR_ID)?.offsetHeight!;

    const verticalSxProps: SxProps<Theme> = {
        bottom: theme => theme.spacing(3),
        left: 0,
        flexDirection: "column",
        width: "100%"
    };

    const horizontalSxProps: SxProps<Theme> = {
        right: 0,
        top: `${appBarHeight}px`,
        flexDirection: "row",
        height: `calc(100% - ${appBarHeight}px)`,
        pb: 1
    };

    return (
        <Box
            display="flex"
            gap={1}
            sx={{
                position: 'fixed',
                zIndex: theme => theme.zIndex.drawer + 1,
                pointerEvents: "none",
                ...(isLandscape ? horizontalSxProps : verticalSxProps)
            }}
        >
            <Box display="flex" justifyContent="flex-end" alignItems="flex-end" mx={2}>
                <Box sx={{ pointerEvents: "auto" }}>
                    <AttachmentsUploadStatusDrawer />
                </Box>
            </Box>
            {showQuickAccessKeys && !isMeetingActive && (
                <Box sx={{ pointerEvents: "none" }}>
                    <QuickAccessKeys/>
                </Box>
            )}
        </Box >
    );
};